module.exports = __webpack_public_path__ + "static/media/london_getty_desktop.9ca4a6aa.jpg";